export enum KamstrupLicenses {
  READyPlusDashboardLicense = "READyPlusDashboard",
  READyPlusAlarmsLicense = "READyPlusAlarms",
  READyPlusCustomerServiceLicense = "READyPlusCustomerService",
  READyPlusNetworkMonitorLicense = "READyPlusNetworkMonitor",
  LeakDetectorLicense = "LeakDetector",
}
export interface GetAvailableLicensesResponse {
  licensesAvailable: KamstrupLicenses[];
}
